import { ApplicationFormValues } from "@lib/mapApplicationData/types";
import { FC } from "react";
import LeadWall from ".";
import { FormStepComponent } from "../FormSteps/FormSteps";

const CertificateLeadWall: FC<FormStepComponent<ApplicationFormValues>> = (
  props,
) => {
  return <LeadWall isCertificate {...props} />;
};

export default CertificateLeadWall;
